<template>
	<el-container>
		<index-header></index-header>
		<el-container>
			<component :is="asideComponent"></component>
			<index-main></index-main>
		</el-container>
	</el-container>
</template>

<script>
	import IndexHeader from '@/components/index/IndexHeader'
	import IndexAside from '@/components/index/IndexAsideStatic'
	import IndexAsideCoach from '@/components/index/IndexAsideCoach'
	import IndexMain from '@/components/index/IndexMain'
	
	export default {
		components: {
			IndexHeader,
			IndexAside,
			IndexAsideCoach,
			IndexMain
		},
		// data() {
		// 	return {
		// 		userInfo: '' // This should be dynamically set based on the actual user role
		// 	}
		// },
		computed: {
      asideComponent() {
        console.log("this ...",this);
        const userInfo = JSON.parse(localStorage.getItem('role'));
    // return userInfo && userInfo === '管理员';
        
        return IndexAside;
        // return userInfo == '教练' ? this.$options.components.IndexAsideCoach : this.$options.components.IndexAside;

      }
    }
	}
</script>

<style lang="scss" scoped>
	// 铺满全屏
	.el-container {
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
		bottom: 0;
	}
</style>

<style scoped>
@media (max-width: 768px) {
  .index-container {
    flex-direction: column;
    align-items: center;
  }

  .index-aside,
  .index-main {
    width: 100%;
    height: auto;
  }

  .index-aside {
    overflow-y: auto;
    max-height: 100vh;
  }
}
</style>
